import {Block} from "../index";
import {GRAMMAR} from "../../Type";
import {
  Animation,
  Axis,
  BooleanBlock,
  Direction,
  Key,
  NumberBlock,
  Position,
  Random,
  Scene,
  StringBlock,
  Time,
  Touch,
} from "./index";

export class Constant extends Block {
  get type() {
    return "Constant";
  }

  get category() {
    return "Constant";
  }

  getGrammarFor() {
    return GRAMMAR.OBJECTIVE;
  }

  static getPrototypeBlocks({gameObjects = [], sceneIds, strings} = {}) {
    const animationIds = this.getAnimationIdsFrom(gameObjects);
    const prototypeBlocks = [
      ...NumberBlock.getPrototypeBlocks(),
      ...StringBlock.getPrototypeBlocks(strings),
      ...BooleanBlock.getPrototypeBlocks(),
      ...Key.getPrototypeBlocks(),
      ...Direction.getPrototypeBlocks(),
      ...Animation.getPrototypeBlocks(animationIds),
      ...Position.getPrototypeBlocks(),
      ...Touch.getPrototypeBlocks(),
      ...Random.getPrototypeBlocks(),
      ...Scene.getPrototypeBlocks(sceneIds),
      ...Axis.getPrototypeBlocks(),
      ...Time.getPrototypeBlocks(),
    ];
    return prototypeBlocks;
  }

  static getAnimationIdsFrom(gameObjects) {
    const animationIdSet = new Set();
    for (let i = 0; i < gameObjects.length; i++) {
      const gameObject = gameObjects[i];
      if (!gameObject.animationIds) continue;
      for (let j = 0; j < gameObject.animationIds.length; j++) {
        const animationId = gameObject.animationIds[j];
        animationIdSet.add(animationId);
      }
    }
    const animationIds = Array.from(animationIdSet);
    return animationIds;
  }

  toJavascript() {
    return `"${this.data}"`;
  }
}
